import React from 'react';
import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';
// Custom SVGs (root-level assets)
import printerSvg from '../../printer.svg';
import filamentSvg from '../../filament.svg';
import projectsSvg from '../../projects.svg';

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    variant = 'lucide',
    ...props
}) {
    // Root-level asset SVGs rendered as <img> to avoid mask square issues
    const ASSET_SVG_MAP = {
        Printer: printerSvg,
        Filament: filamentSvg,
        Projects: projectsSvg,
    };

    const assetSrc = ASSET_SVG_MAP?.[name];
    if (assetSrc) {
        const sizePx = typeof size === 'number' ? `${size}px` : size;
        if (variant === 'masked') {
            // Use CSS mask to allow color via currentColor
            return (
                <span
                    aria-hidden="true"
                    className={className}
                    style={{
                        display: 'inline-block',
                        width: sizePx,
                        height: sizePx,
                        color: color,
                        backgroundColor: 'currentColor',
                        WebkitMaskImage: `url(${assetSrc})`,
                        WebkitMaskRepeat: 'no-repeat',
                        WebkitMaskPosition: 'center',
                        WebkitMaskSize: 'contain',
                        maskImage: `url(${assetSrc})`,
                        maskRepeat: 'no-repeat',
                        maskPosition: 'center',
                        maskSize: 'contain',
                    }}
                    {...props}
                />
            );
        }
        // Default image rendering (no color control)
        return (
            <img
                src={assetSrc}
                alt={name}
                width={size}
                height={size}
                className={className}
                style={{ display: 'inline-block', width: sizePx, height: sizePx }}
                {...props}
            />
        );
    }

    const IconComponent = LucideIcons?.[name];

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;
